<template>
    <button class="button" 
        :disabled="disabled"
        :class="{'disabled': disabled}"
        @click.stop="$emit('click')"
    >
        <span v-if="!isLoading">{{ text }}</span>
        <base-spinner
            :is-local="true"
            :is-loading="isLoading"
            v-else
            :spinner-color="spinnerColor"
        />
    </button>
</template>

<script>
import BaseSpinner from './BaseSpinner.vue'
export default {
  components: { BaseSpinner },
    name: 'BaseButton',
    props: {
        text: String,
        isLoading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        spinnerColor: {
            type: String,
            default() {
                return 'var(--base-button-spinner-color)';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    width: 100%;
    height: 100%;
    padding: 19px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--base-button-bgc);
    border: none;
    outline: none;
    border-radius: 10px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: var(--base-button-color);
    cursor: pointer;

    &.disabled {
        background-color: rgba(64, 191, 123, 0.5);
    }
}
</style>